import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.scss";
import { initEnvironment } from "./hooks/environment.ts";

initEnvironment();
createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <App />,
  // </StrictMode>
);
